export const PageTitle = ({ title }: { title: string }) => {
  return (
    <div className="text-[#333] text-center font-['Alibaba_PuHuiTi_3.0'] text-[45px] font-bold leading-[120%] tracking-[4.5px]">
      {title}
    </div>
  );
};

export const PageTitleEn = ({ title }: { title: string }) => {
  return (
    <div className="text-[rgba(51,51,51,0.50)] text-center font-['Alibaba_PuHuiTi_3.0'] text-[1.5rem] font-light leading-none tracking-[0.3rem] uppercase mt-[0.62rem]">
      {title}
    </div>
  );
};

export const PageSubTitle = ({ title }: { title: string }) => {
  return (
    <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 3.0] font-normal text-[20px] text-[#777777] text-center mt-[12px]">
      {title}
    </div>
  );
};
